import FdxUI from '@ajs/services/fdxUI';
import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@app/core/providers/document.provider';
import { CheatSheetContentType } from '@app/modules/cheat-sheet/models/cheat-sheet-content.type';
import { CheatSheetService, CheatSheetTab, CheatSheetTabTitles } from '@app/modules/cheat-sheet/services/cheat-sheet.service';

import { IconDefinition, faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'fdx-cheat-sheet',
    templateUrl: './cheat-sheet.component.html',
    styleUrl: './cheat-sheet.component.scss',
    standalone: false
})
export class CheatSheetComponent {

    @Input() onCheatSheetPage: boolean = true;

    readonly tabs: CheatSheetTab[] = this.cheatSheetService.tabs;
    currentSection: string = this.encodeString(CheatSheetTabTitles.Intro);

    readonly tabOffset: number = 24;  // page padding bottom
    readonly pageOffset: number = 16 + 1 + 24;  // card padding bottom + card border bottom + page padding bottom

    readonly newTabIcon: IconDefinition = faUpRightFromSquare;

    get offset(): number {
        return this.onCheatSheetPage ? this.pageOffset : this.tabOffset;
    }

    constructor(
        @Inject(DOCUMENT) private readonly document: Document,
        private readonly cheatSheetService: CheatSheetService,
        private readonly clipboard: Clipboard,
        private readonly fdxUi: FdxUI
    ) { }

    onSectionChange(sectionId: string): void {
        this.currentSection = sectionId;
    }

    tabClass(title: string): string {
        if (this.currentSection === this.encodeString(title) || this.currentSection.includes(this.encodeString(title))) {
            return 'active';
        }
        return '';
    }

    groupClass(title: string): string {
        if (this.currentSection === this.encodeString(title)) {
            return 'active';
        }
        return '';
    }

    scrollTo(destination: string): void {
        const query = `#${this.encodeString(destination)}`;
        const shadowRoot = this.document.getElementsByTagName('fdx-style-wrapper')[0].shadowRoot;

        if (shadowRoot) {
            shadowRoot.querySelector(query)?.scrollIntoView({ behavior:'smooth' });
        }
    }

    encodeString(str: string): string {
        return str.toLowerCase().split(/ |\//).join('_');
    }

    isTitleOnly(data: CheatSheetContentType): boolean {
        return this.cheatSheetService.isTitleOnly(data);
    }

    copyToClipboard(event: Event): void {
        const copied = this.clipboard.copy((event.target as Element).textContent);
        if (copied) {
            this.fdxUi.showToastSuccess('Copied to clipboard');
        } else {
            this.fdxUi.showToastError('Failed to copy to clipboard');
        }
    }
}
